<template>
  <div class="input-wrap">
    <label v-if="label !== 'none'"
      >{{ label }}
      <span v-if="required" class="required">※必須</span>
    </label>
    <p v-if="isTap" class="input-description">２回押すと解除できます</p>

    <span class="valid" v-if="alert">
      入力項目が空または正しい形式ではありません。</span
    >
    <div class="input-flex">
      <div class="input-group" v-for="(option, index) in options" :key="index">
        <input
          type="checkbox"
          :name="setKey"
          :id="`${setKey}_${index}`"
          :value="option"
          @change="updateValue"
          :checked="value.includes(option)"
        />
        <label class="block" :for="`${setKey}_${index}`">{{ option }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Array, required: true },
    label: { type: String, required: true },
    value: { type: [Array, String], required: true, default: null },
    setKey: { type: String, required: true },
    alert: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    isTap: { type: Boolean, required: false },
  },
  methods: {
    updateValue(e) {
      if (!this.value.includes(e.target.value)) {
        this.$emit('input-emit', this.setKey, [e.target.value])
      } else {
        this.$emit('input-emit', this.setKey, [])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.input-flex {
  .input-group {
    width: calc(25% - 10px);
  }
}

.input-group label.block {
  width: 100%;
  min-width: auto;
  margin-left: 0;
  margin-right: 0;
}

.input-flex {
  display: flex;
  justify-content: space-between;
}
</style>
